import { render, staticRenderFns } from "./DialogMarcarPartida.vue?vue&type=template&id=43dcbc25&"
import script from "./DialogMarcarPartida.vue?vue&type=script&lang=js&"
export * from "./DialogMarcarPartida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports